<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main class="main main--has-floating-buttons">
    <card :title="$t('pageListReports.card.listReports')" cols="12">
      <hm-card-inner>
        <hm-col :grid="true" cols="12">
          <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="yesterday()">{{ $t('pageListReports.yesterday') }}</hm-button>
          <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="today()">{{ $t('pageListReports.today') }}</hm-button>
          <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="tomorrow()">{{ $t('pageListReports.tomorrow') }}</hm-button>
          <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="thisWeek()">{{ $t('pageListReports.thisWeek') }}</hm-button>
          <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="previousMonth()">{{ $t('pageListReports.previousMonth') }}</hm-button>
          <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="thisMonth()">{{ $t('pageListReports.thisMonth') }}</hm-button>
        </hm-col>
        <hm-input-date ref="startDate"
                       v-model="search.startDate"
                       :max-date="maxHotelDate"
                       :label="$t('pageListReports.startDate')"
                       cols="12 2@hd 2@desktop 6@tablet"
                       name="startDate" />
        <hm-input-date ref="endDate"
                       v-model="search.endDate"
                       :max-date="maxHotelDate"
                       :min-date="search.startDate"
                       :min-date-inclusive="true"
                       :max-days="-1"
                       :label="$t('pageListReports.endDate')"
                       cols="12 2@hd 2@desktop 6@tablet"
                       name="endDate" />
        <hm-input v-model="filter"
                  :lazy="false"
                  :label="$t('pageListReports.filter')"
                  name="filter"
                  cols="12 2@hd start-11@hd 3@desktop start-10@desktop 6@tablet start-7@tablet">
          <template slot="icon-inline-left" slot-scope="slot">
            <icon icon="filter" />
          </template>
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-if="!isEmpty(filter)" :border="false" icon="close-text" @click="filter = null" />
          </template>
        </hm-input>
      </hm-card-inner>
      <hm-card-inner :full-size="true">
        <paginated-table :items-per-page="25"
                         :rows="filteredRows"
                         :sticky="true"
                         min-width="600px"
                         grid-template-columns="5rem 25rem auto 20rem"
                         columns="4">
          <template slot="table-head">
            <div class="hm-table__th"></div>
            <div class="hm-table__th">{{ $t('pageListReports.search.date') }}</div>
            <sortable-th field="name">{{ $t('pageListReports.search.name') }}</sortable-th>
            <div class="hm-table__th">{{ $t('pageListReports.search.action') }}</div>
          </template>
          <template v-slot:default="slotProps">
            <template v-for="row in slotProps.currentPage">
              <div v-if="favorites.includes(row.id)" class="hm-table__td hm-table__td--no-hover color--mint cursor--pointer"><i class="fas fa-star" @click="toggleFavorite(row.id)"></i></div>
              <div v-else class="hm-table__td hm-table__td--no-hover"><i class="fal fa-star cursor--pointer" @click="toggleFavorite(row.id)"></i></div>
              <div v-if="row.dateRange === false" class="hm-table__td" @click="openReport(row.id)">{{ $t('pageListReports.search.allPeriods') }}</div>
              <div v-else-if="row.dateRange === 'to'" class="hm-table__td" @click="openReport(row.id)">{{ beginningOfTime | toDate }} - {{ search.endDate | toDate }}</div>
              <div v-else-if="row.dateRange === 'from'" class="hm-table__td" @click="openReport(row.id)">{{ search.startDate | toDate }} - {{ endOfTime | toDate }}</div>
              <div v-else-if="row.dayMonthOnly === true" class="hm-table__td" @click="openReport(row.id)">{{ search.startDate | toDayMonthDate }} - {{ search.endDate | toDayMonthDate }}</div>
              <div v-else class="hm-table__td" @click="openReport(row.id)">{{ search.startDate | toDate }} - {{ search.endDate | toDate }}</div>
              <div class="hm-table__td" @click="openReport(row.id)">{{ row.name }}</div>
              <div v-if="row.download === true" class="hm-table__td hm-table__td--icon text-right" >
                <span class="quick-action-button" @click="openReport(row.id)">
                  <icon icon="download" />
                </span>
              </div>
              <div v-else class="hm-table__td hm-table__td--icon hm-table__td--no-hover text-right" >
                <span v-if="isEmpty(row.url) && isEmpty(row.legacy)" class="quick-action-button" @click="openReport(row.id, 'csv')">
                  <icon icon="download" />
                </span>
                <span class="quick-action-button" @click="openReport(row.id)">
                  <icon icon="html" />
                </span>
                <span class="quick-action-button" @click="openReport(row.id, 'pdf')">
                  <icon icon="pdf" />
                </span>
              </div>
            </template>
          </template>
        </paginated-table>
      </hm-card-inner>
    </card>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil, isEmpty, lowerCase, remove, sortBy, keyBy, template } from 'lodash';
import PageMixin from '../../mixins/PageMixin';
import Reports from '@/lib/reports';

export default {
  name: 'PageListReports',

  mixins: [HotelmeisterMixin, PageMixin],

  data() {
    return {
      search: {
        startDate: null,
        endDate: null,
      },
      filter: null,
      favorites: [],
      pageLoaded: false,
      beginningOfTime: '19700101',
      endOfTime: '20991231',
    };
  },

  computed: {
    maxHotelDate: function () {
      return this.$moment().add(this.hotelSettings.details.futureDates, 'days').format('YYYYMMDD');
    },
    filteredRows: function () {
      let ret = this.rows;

      if (!isEmpty(this.filter)) {
        ret = ret.filter(it => Object.values(it).filter(str => !isEmpty(str) && !isEmpty(str) && (typeof str === 'string' ? str.toLowerCase() : lowerCase(str)).indexOf(this.filter.toLowerCase()) >= 0).length > 0);
      }

      return ret;
    },
    rows: function () {
      // required for eval
      const hasLicense = this.hasLicense;
      const hasRole = this.hasRole;
      const hotelSettings = this.hotelSettings;

      return sortBy(
        // eslint-disable-next-line
        Reports.list
          .filter((it) => {
            if (isEmpty(it.condition)) {
              return this.hasRole('ROLE_USER');
            } else if (!it.condition.includes('hasRole')) {
              // eslint-disable-next-line no-eval
              return eval(it.condition) && this.hasRole('ROLE_USER');
            } else {
              // eslint-disable-next-line no-eval
              return eval(it.condition);
            }
          })
          .map(it => ({
            ...it,
            name: this.$t(`reports.${it.id}`),
            favorite: this.favorites.includes(it.id) ? 1 : 999,
          })),
        ['favorite', 'name'],
      );
    },
    reportsById: function () {
      return keyBy(this.rows, 'id');
    },
  },

  watch: {
    favorites: function () {
      localStorage.setItem(`${this.$root.hotel}__${this.$root.username}__reportFavorites`, JSON.stringify(this.favorites));
    },
  },

  created: function () {
    this.favorites = JSON.parse(localStorage.getItem(`${this.$root.hotel}__${this.$root.username}__reportFavorites`) || '[]') || [];

    this.today();
  },

  methods: {
    toggleFavorite: function (reportId) {
      if (this.favorites.includes(reportId)) {
        this.favorites = remove(this.favorites, it => it !== reportId);
      } else {
        this.favorites.push(reportId);
      }
    },
    openReport: function (reportId, format = null) {
      const report = this.reportsById[reportId];

      let url;
      if (!isEmpty(report.legacy)) {
        url = `/rest/ui/backend${this.serviceUrls.report.legacy(this, report.legacy)}.html`;
      } else if (!isEmpty(report.url)) {
        url = `/pages/reports${report.url}`;
      } else {
        url = `/rest/ui/backend${this.serviceUrls.report.get(this, reportId)}`;
      }

      if (report.dateRange !== false) {
        switch (report.dateRange) {
          case 'to':
            url = `${url}?reportEndDate=${this.search.endDate}`;
            break;
          case 'from':
            url = `${url}?reportStartDate=${this.search.startDate}`;
            break;
          default:
            url = `${url}?reportStartDate=${this.search.startDate}&reportEndDate=${this.search.endDate}`;
            break;
        }
      }

      if (!isNil(report.params)) {
        Object.entries(report.params).forEach(([key, value]) => {
          url = `${url}${url.includes('?') ? '&' : '?'}${key}=${value}`;
        });
      }

      if (format === 'csv' && !url.includes('accept=text/csv')) {
        url = `${url}${url.includes('?') ? '&' : '?'}accept=text/csv`;
      }

      if (format === 'pdf') {
        url = `${url}${url.includes('?') ? '&' : '?'}outputType=pdf`;
      }

      // if (!isEmpty(report.url)) {
      //   url = `${url}${url.includes('?') ? '&' : '?'}title=${encodeURI(report.name.replace(/\([^)]+\)/, ''))}`;
      // }

      url = `${url}${url.includes('?') ? '&' : '?'}title=${encodeURI(report.name)}`;

      window.openOldUI(
        isEmpty(report.url) ? 'report' : this.hotelSettings.tenant.subdomain,
        this.hotelSettings.hotel.id,
        url,
        window.getToken(this.$root.hotel),
        this.$shortLocale === 'de' ? this.$shortLocale : 'en',
      );
    },
    yesterday() {
      this.jumpToDate(-1);
    },
    today() {
      this.jumpToDate(0);
    },
    tomorrow() {
      this.jumpToDate(1);
    },
    jumpToDate(offset) {
      this.search.startDate = this.$moment().add(offset, 'days').format('YYYYMMDD');
      this.$nextTick(() => {
        this.search.endDate = this.$moment().add(offset, 'days').format('YYYYMMDD');
        if (this.pageLoaded === true) {
          this.$refs.startDate.glow();
          this.$refs.endDate.glow();
        } else {
          this.pageLoaded = true;
        }
      });
    },
    thisWeek() {
      this.jumpToPeriod(0, 'week');
    },
    previousWeek() {
      this.jumpToPeriod(-1, 'week');
    },
    thisMonth() {
      this.jumpToPeriod(0, 'month');
    },
    previousMonth() {
      this.jumpToPeriod(-1, 'month');
    },
    jumpToPeriod(offset, quantifier) {
      this.search.startDate = this.$moment().add(offset, quantifier).startOf(quantifier).format('YYYYMMDD');
      this.$nextTick(() => {
        this.search.endDate = this.$moment().add(offset, quantifier).endOf(quantifier).format('YYYYMMDD');
        this.$refs.startDate.glow();
        this.$refs.endDate.glow();
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-table__td {
    cursor: pointer;
  }
</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/PageListReports.vue